import { render } from "./FileAttachment.vue?vue&type=template&id=5e19a38a"
import script from "./FileAttachment.vue?vue&type=script&lang=js"
export * from "./FileAttachment.vue?vue&type=script&lang=js"

import "./FileAttachment.vue?vue&type=style&index=0&id=5e19a38a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtnDropdown from 'quasar/src/components/btn-dropdown/QBtnDropdown.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtnDropdown,QList,QItem,QItemSection,QIcon,QItemLabel,QBtn});qInstall(script, 'directives', {Ripple});
